'use client';

import React from 'react';
import Checkbox from '../primitives/Checkbox/Checkbox';
import PopoverWrapper from '../PopoverWrapper';
import useTargetedPopover from 'src/hooks/useTargetedPopover';
import { Filter } from '@velocity-exchange/icons';
import Button from 'src/components/primitives/Button/Button';

export type PositionsAndOrdersFilterOption = {
	type:
		| 'perpMarkets'
		| 'predictionMarkets'
		| 'spotMarkets'
		| 'selectedMarketOnly';
	label: string;
	value: boolean;
	disabled?: boolean;
};

const PositionsAndOrdersFilterDropdown = ({
	filterOptions,
	onChange,
}: {
	filterOptions: PositionsAndOrdersFilterOption[];
	onChange: (updatedOption: PositionsAndOrdersFilterOption) => void;
	buttonHelperText?: string;
}) => {
	const {
		refs,
		floatingStyles,
		getReferenceProps,
		getFloatingProps,
		setIsPopoverOpen,
		isPopoverOpen,
	} = useTargetedPopover(
		{
			placement: 'top',
			strategy: 'fixed',
		},
		{
			disableAutoPlacement: false,
		}
	);

	const toggleExpanded = () => setIsPopoverOpen(!isPopoverOpen);

	const toggleFilterOption = (option: PositionsAndOrdersFilterOption) => {
		onChange({
			...option,
			value: !option.value,
		});
	};

	return (
		<>
			<Button
				size="sm"
				variant="secondary"
				onClick={toggleExpanded}
				className="whitespace-nowrap"
				ref={refs.setReference}
				{...getReferenceProps()}
				leftIcon={Filter}
			>
				{filterOptions.reduce((acc, option) => acc + (option.value ? 1 : 0), 0)}
			</Button>

			{isPopoverOpen && (
				<PopoverWrapper
					ref={refs.setFloating}
					style={floatingStyles}
					{...getFloatingProps()}
				>
					<div className="p-1">
						{filterOptions.map((option) => {
							return (
								<div
									className="mx-3 border-b border-stroke-divider py-3 last:border-none"
									key={option.type}
								>
									<Checkbox.Default
										id={`position-and-orders-filter-${option.type}`}
										checked={option.value}
										onCheckedChange={() => {
											toggleFilterOption(option);
										}}
										label={option.label}
										className="pr-4 text-text-default"
										disabled={option.disabled}
									/>
								</div>
							);
						})}
					</div>
				</PopoverWrapper>
			)}
		</>
	);
};

export default PositionsAndOrdersFilterDropdown;
